import React from 'react';
import { ProgressBar } from 'react-bootstrap';

/**
 * Componente de barra de progreso simple con componentes individuales
 */
const ProgressBarWithComponents = ({ loadingComponents, calculateTotalProgress }) => {
    const componentColors = {
        table: "#2E7D32",      // Verde oscuro
        vehicles: "#1976D2",   // Azul 
        alerts: "#D32F2F",     // Rojo
        map: "#7B1FA2",        // Púrpura
        frequency: "#F57C00"   // Naranja
    };

    const activeComponents = Object.entries(loadingComponents)
        .filter(([_, state]) => state.loading || state.complete)
        .map(([component, state]) => ({
            component,
            color: componentColors[component],
            progress: state.progress,
            isComplete: state.complete
        }));

    if (activeComponents.length === 0) return null;

    const totalProgress = calculateTotalProgress();

    return (
        <>
            <div className="d-flex justify-content-between small mb-1">
                <span>Generando reporte: {totalProgress.toFixed(0)}%</span>
                <span className="text-muted">
                    {Object.values(loadingComponents).filter(c => c.complete).length}
                    /{Object.keys(loadingComponents).length} componentes listos
                </span>
            </div>

            <ProgressBar style={{ height: 12 }} className="shadow-none rounded-4">
                {activeComponents.map(({ component, color, progress, isComplete }) => (
                    <ProgressBar
                        key={component}
                        style={{ backgroundColor: color }}
                        now={progress * (1 / activeComponents.length)}
                        animated={!isComplete}
                        className="position-relative"
                    />
                ))}
            </ProgressBar>

            <div className="d-flex justify-content-between mt-1 small text-muted">
                {activeComponents.map(({ component, color, isComplete }) => (
                    <div key={component} className="d-flex align-items-center">
                        <span
                            className="dot mr-1"
                            style={{
                                backgroundColor: color,
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                display: 'inline-block',
                                marginRight: 5
                            }}
                        />
                        <span>
                            {component.charAt(0).toUpperCase() + component.slice(1)}
                            {isComplete && <i className="fas fa-check-circle ml-1 text-success" />}
                        </span>
                    </div>
                ))}
            </div>
        </>
    );
};

export default ProgressBarWithComponents;